import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Page404Component } from './authentication/page404/page404.component';
import { AuthGuard } from './core/guard/auth.guard';
import { Role } from './core/models/role';
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: '/authentication/signin', pathMatch: 'full' },
      {
        path: 'intranet',
        canActivate: [AuthGuard],
        data: {
          role: Role.Admin
        },
        loadChildren: () =>
          import('./intranet/intranet.module').then((m) => m.IntranetModule)
      },
      {
        path: 'catalogos',
        canActivate: [AuthGuard],
        data: {
          role: Role.Admin
        },
        loadChildren: () =>
          import('./catalogos/catalogos.module').then((m) => m.CatalogosModule)
      },
      {
        path: 'aplicacion',
        canActivate: [AuthGuard],
        data: {
          role: Role.Admin
        },
        loadChildren: () =>
          import('./aplicacion/aplicacion.module').then((m) => m.AplicacionModule)
      },
      {
        path: 'medicos',
        canActivate: [AuthGuard],
        data: {
          role: Role.Doctor
        },
        loadChildren: () =>
          import('./medicos/medicos.module').then((m) => m.MedicosModule)
      },
      {
        path: 'empresas',
        canActivate: [AuthGuard],
        data: {
          role: Role.Company
        },
        loadChildren: () =>
          import('./empresas/empresas.module').then((m) => m.EmpresasModule)
      },
      {
        path: 'representantes',
        canActivate: [AuthGuard],
        data: {
          role: Role.Representantes
        },
        loadChildren: () =>
          import('./representantes/representantes.module').then(
            (m) => m.RepresentantesModule
          )
      },
      {
        path: 'pacientes',
        canActivate: [AuthGuard],
        data: {
          role: Role.Paciente
        },
        loadChildren: () =>
          import('./pacientes/pacientes.module').then((m) => m.PacientesModule)
      },
      {
        path: 'admin',
        canActivate: [AuthGuard],
        data: {
          role: Role.Admin
        },
        loadChildren: () =>
          import('./admin/admin.module').then((m) => m.AdminModule)
      }
    ]
  },
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      )
  },
  { path: '**', component: Page404Component }
]
@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  // imports: [RouterModule.forRoot(routes,{useHash: true})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
